module.exports = __webpack_public_path__ + "static/logo1-24fd0a51e24c8dd6aa33b56bcadfa59b.jpg";